import { render, staticRenderFns } from "./ResourcesMenu.vue?vue&type=template&id=f62b72f6&"
import script from "./ResourcesMenu.vue?vue&type=script&lang=js&"
export * from "./ResourcesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports